import styled from "styled-components";

/**
 * Метка времени реплики: сверху время от начала папки, под ним — от начала всего видео.
 *
 * Колонка узкая (`--audio-time-width: 3.5em`, от неё считается вёрстка обеих колонок дорожек), а
 * «0:01:48» занимает почти всю ширину. Второе число в ту же строку не влезает, а расширять
 * колонку — значит отнять место у текста субтитров. Поэтому две строки, ширина прежняя.
 */
export const CueTimeWrapSC = styled.div<{ $side: "left" | "right" }>`
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: ${({ $side }) => ($side === "left" ? "flex-end" : "flex-start")};
    /* Иначе пара строк не помещается в самую короткую реплику (FRAGMENT_MIN_HEIGHT = 25px). */
    line-height: 1;
    white-space: nowrap;
    margin-left: 0.2em;
    margin-right: 0.2em;
    font-family:
        Ubuntu Mono,
        sans-serif;
    position: absolute;
    top: 0;
    bottom: auto;
    right: ${({ $side }) => ($side === "left" ? "101%" : "auto")};
    left: ${({ $side }) => ($side === "left" ? "auto" : "101%")};
`;

/** Время от начала папки — ровно то, что было здесь всегда: шрифт и вес не менялись. */
export const CueTimeLocalSC = styled.div`
    font-size: 0.8em;
    font-weight: 400;
`;

/**
 * Время от начала видео.
 *
 * Отличается от верхнего тремя независимыми признаками — положением, чертой и начертанием. Цветом
 * не отличается намеренно: синий, оранжевый, жёлтый и красный в этом редакторе уже заняты
 * выделением, сдвигом, пересборкой и обрезкой, и пятый оттенок начал бы с ними спорить.
 */
export const CueTimeGlobalSC = styled.div`
    font-size: 0.66em;
    font-weight: 600;
    color: #4a5568;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    padding-top: 1px;
`;
